import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { hostUrl } from './config';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await axios.post(`${hostUrl}/password-reset/`, { email });
      setMessage(response.data?.detail || 'If the email exists, a reset link has been sent.');
    } catch (err) {
      const errorMsg = err.response?.data?.detail || err.message || 'Failed to send reset email.';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="col-md-12">
      <div className="card card-container">
        <h4 className="mb-3">Reset Password</h4>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group mt-3">
            <button className="btn btn-primary btn-block" disabled={loading}>
              {loading && <span className="spinner-border spinner-border-sm me-2"></span>}
              <span>Send Reset Link</span>
            </button>
          </div>

          {message && (
            <div className="form-group mt-3">
              <div className="alert alert-success" role="alert">
                {message}
              </div>
            </div>
          )}

          {error && (
            <div className="form-group mt-3">
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            </div>
          )}
        </form>

        <div className="mt-3">
          <Link to="/login">Back to login</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
